import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/auth";
import homeSlice from "./slices/home";


export default configureStore({
  reducer: {
    auth: authSlice,
    home: homeSlice
  }
});
